import { Injectable } from '@angular/core'
import { AngularFireFunctions } from '@angular/fire/compat/functions'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { Leaderboard } from '../models/leaderboard.model'

@Injectable({
  providedIn: 'root',
})
export class LeaderboardService {
  constructor(private cloudFunctions: AngularFireFunctions) {}

  getLeaderboard(): Observable<Leaderboard> {
    return this.cloudFunctions
      .httpsCallable('getLeaderboard')({})
      .pipe(
        map(response => ({
          items: Array.isArray(response?.items) ? response.items.map(item => ({ ...item, hours: item.hours || 0 })) : [],
          me: response?.me ? { ...response.me, hours: response.me.hours || 0 } : null,
          total: response?.total || 0,
          totalScore: response?.totalScore || 0,
          totalHours: response?.totalHours || 0,
        }))
      )
  }
}
